import { Link } from 'react-router-dom';
import heroImage from '../assets/images/KenaydaLive.jpeg';
import hilden from '../assets/images/hilden.jpeg';
import poser from '../assets/images/poser.jpg';
import orphans from '../assets/images/orphans-web.jpg';
import VideoEmbed from '../components/VideoEmbed';
import GigList from '../components/GigList';
import { upcomingGigs } from '../data/gigs';
import { videos, BANDCAMP_ALBUM_URL } from '../data/videos';

const quotes = [
    {
        text: "…an exhilarating twist on evergreen 1990s complaint rock… downtuned guitars, uplifting choruses and more hooks than a party at Pinhead's house…",
        source: 'Edwin McFee, Belfast Telegraph',
    },
    {
        text: '…another standout slice of Irish alternative rock that deserves to be heard.',
        source: 'Chris Kennedy, Beat.ie',
    },
]

const Home = () => {
    const sunCityPoms = videos[0]

    return (
        <>
            <section className='hero'>
                <div className='hero__inner'>
                    <div className='hero__copy'>
                        <h1 className='hero__title'>O, Kenayda</h1>
                        <p className='hero__sub'>Debut album <em>Orphans</em> — out now</p>
                        <div className='actions'>
                            <a className='btn btn--solid' href={BANDCAMP_ALBUM_URL} target='_blank' rel='noreferrer'>Buy the album</a>
                            <Link className='btn' to='/listen'>Listen</Link>
                        </div>
                    </div>
                    <figure className='hero__figure'>
                        <img src={heroImage} alt='O, Kenayda on stage at Voodoo, Belfast' />
                        <figcaption>Live at Voodoo, Belfast — 2025</figcaption>
                    </figure>
                </div>
            </section>

            <section className='band band--light'>
                <div className='container release'>
                    <a className='release__art' href={BANDCAMP_ALBUM_URL} target='_blank' rel='noreferrer'>
                        <img src={orphans} alt="'Orphans' album cover" />
                    </a>
                    <div className='release__copy'>
                        <p className='eyebrow'>Debut album · 26 June 2026</p>
                        <h2 className='heading heading--xl'>Orphans</h2>
                        <p className='body-lg'>
                            Built on downtuned guitars, big choruses and hooks that don’t let go, the record updates the
                            spirit of 1990s alt-rock for a contemporary audience — loud where it needs to be, melodic where it counts.
                        </p>
                        <p>
                            Every song was heard for the first time on the day it was recorded, tracked in a single day,
                            with different personnel on every recording.
                        </p>
                        <div className='actions'>
                            <a className='btn btn--solid' href={BANDCAMP_ALBUM_URL} target='_blank' rel='noreferrer'>Order on Bandcamp</a>
                            <Link className='btn' to='/about'>Learn more</Link>
                        </div>
                    </div>
                </div>
            </section>

            {upcomingGigs.length > 0 && (
                <section className='band'>
                    <div className='container'>
                        <div className='section-head'>
                            <h2 className='heading'>Upcoming shows</h2>
                            <Link className='link-arrow' to='/live'>All live shows</Link>
                        </div>
                        <GigList gigs={upcomingGigs.slice(0, 4)} />
                    </div>
                </section>
            )}

            <section className='band band--panel'>
                <div className='container container--narrow'>
                    <div className='section-head section-head--center'>
                        <p className='eyebrow'>New video</p>
                        <h2 className='heading'>{sunCityPoms.title}</h2>
                    </div>
                    <VideoEmbed video={sunCityPoms} />
                    <p className='video-note'>
                        The Sun City Poms are an over 55s cheerleading troupe from Arizona. For the last 45 years, they have
                        inspired the world with magnetic routines, sisterly solidarity and a positive message that
                        'age is just a number' — this is NOT their story.
                    </p>
                </div>
            </section>

            <section className='band'>
                <div className='container quotes'>
                    {quotes.map((quote) => (
                        <blockquote className='quote' key={quote.source}>
                            <p>“{quote.text}”</p>
                            <cite>{quote.source}</cite>
                        </blockquote>
                    ))}
                </div>
                <div className='container section-foot'>
                    <Link className='link-arrow' to='/press'>All press</Link>
                </div>
            </section>

            <section className='photo-strip' aria-label='Live photos'>
                <img src={hilden} alt='O, Kenayda at Hilden Beer Festival' loading='lazy' />
                <img src={heroImage} alt='O, Kenayda at Voodoo, Belfast' loading='lazy' />
                <img src={poser} alt='Solo acoustic set' loading='lazy' />
            </section>
        </>
    )
}
export default Home
